<template>
<div v-if="stroll">
  <div v-if="userInRadius">
    <div :is="messageTag">
      <v-icon class="inline-icon blue--text">my_location</v-icon>
      You are close enough to view this content!
    </div>
    <slot></slot>
  </div>
  <div v-else class="grey--text">
    <p>
      More content is available in person.
      Travel within {{ stroll.in_person_radius|distance }} to see more!
    </p>
    <div :is="messageTag">
      <v-icon class="inline-icon">my_location</v-icon>
      Your distance: {{ userDistanceFromStroll|distance }}
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StrollInPersonMessage',

  props: {
    stroll: {
      type: Object,
    },

    messageTag: {
      type: String,
      default: 'p',
    }
  },

  data() {
    return {
      userDistanceFromStroll: -1,
    }
  },

  computed: {
    ...mapGetters({
      location: 'getLocation',
      locationFetched: 'getLastUpdateStatus',
    }),

    userInRadius() {
      if (this.userDistanceFromStroll < 0) {
        return false
      }
      return this.userDistanceFromStroll < this.stroll.in_person_radius
    }
  },

  async mounted() {
    await this.setUserDistanceFromStroll()
  },

  watch: {
    async location() {
      this.setUserDistanceFromStroll()
    }
  },

  methods: {
    ...mapActions(['calculateUserDistanceFromStroll']),

    async setUserDistanceFromStroll() {
      if (!this.locationFetched.success) {
        this.userDistanceFromStroll = -1
        return
      }
      const distance = await this.calculateUserDistanceFromStroll({stroll: this.stroll, userLocation: this.location})
      this.userDistanceFromStroll = distance
    }
  }
}
</script>

<style lang="sass" scoped>
.inline-icon
  font-size: 1.25em
</style>
